import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import * as actions from '../../store/resellerSelectedManagedOrgDevPlan/actions';
import { makeSelectDeveloperPlanConsume, selectDeveloperPlanConsumeOrg, selectDeveloperPlanStatus, selectDeveloperPlanStatusLoading, makeSelectActiveDeveloperPlan, makeSelectActiveBundles, selectActiveBundlesOrg, selectDeveloperPlansOrg, selectDevPlanStatusOrg, selectDevPlanBundles, selectDevPlanInvoiceDetailsOrg, selectDevPlanInvoiceDetails, selectPurchaseDevPlanBundleLoading, selectPurchaseDevPlanBundleError, } from '../../store/resellerSelectedManagedOrgDevPlan/selectors';
import DevPlanCancelConfirmModal from '../../components/DeveloperPlans/DevPlanCancelConfirmModal';
import { selectOrganizations } from '../Root/selectors';
import { useSuccessToast } from '../../utils/hooks/toast';
import { Helmet } from 'react-helmet';
import { PageHeader, PageHeaderTitle, PageWrapper, } from '../../components/Page';
import Breadcrumbs from '../../components/OrgBreadcrumbs';
import DevPlanUsageComponent from '../../components/DeveloperPlans/DevPlanUsageComponent';
var ResellerSelectedManagedOrgDevPlansPage = function (_a) {
    var listDeveloperPlans = _a.listDeveloperPlans, match = _a.match, organizations = _a.organizations, devPlanConsume = _a.devPlanConsume, devPlanStatus = _a.devPlanStatus, devPlanStatusOrg = _a.devPlanStatusOrg, devPlanStatusLoading = _a.devPlanStatusLoading, cancelDevPlan = _a.cancelDevPlan, devPlanCancel_error = _a.devPlanCancel_error, devPlanCancel_loading = _a.devPlanCancel_loading, reactivateDevPlan = _a.reactivateDevPlan, getDevPlanStatus = _a.getDevPlanStatus, devPlanReactivate_error = _a.devPlanReactivate_error, devPlanReactivate_loading = _a.devPlanReactivate_loading, getManagedOrgConsumedDeveloperPlan = _a.getManagedOrgConsumedDeveloperPlan, activeDeveloperPlan = _a.activeDeveloperPlan, developerPlanPurchase_error = _a.developerPlanPurchase_error, developerPlanPurchase_loading = _a.developerPlanPurchase_loading, purchasedDeveloperPlan = _a.purchasedDeveloperPlan, activeBundles = _a.activeBundles, activeBundlesOrg = _a.activeBundlesOrg, getActiveBundles = _a.getActiveBundles, devPlanConsumeOrg = _a.devPlanConsumeOrg, developerPlansOrg = _a.developerPlansOrg, bundles = _a.bundles, listBundles = _a.listBundles, getDevPlanInvoiceDetails = _a.getDevPlanInvoiceDetails, devPlanInvoiceDetails = _a.devPlanInvoiceDetails, devPlanInvoiceDetailsOrg = _a.devPlanInvoiceDetailsOrg, purchase_dev_plan_bundle_loading = _a.purchase_dev_plan_bundle_loading, purchase_dev_plan_bundle_error = _a.purchase_dev_plan_bundle_error;
    var _b = match.params, resellerOrgId = _b.resellerOrgId, managedOrgId = _b.managedOrgId;
    var resellerOrg = organizations.find(function (org) { return org.id === resellerOrgId; });
    var managedOrg = organizations.find(function (org) { return org.id === managedOrgId; });
    var _c = useState(false), openDevPlanCancelConfirmationModal = _c[0], setOpenDevPlanCancelConfirmationModal = _c[1];
    var crumbs = [{ to: '', text: 'Developer Plans' }];
    if (managedOrgId) {
        crumbs = [
            { to: '/partner/resellers', text: 'Resellers' },
            {
                to: "/partner/resellers/".concat(resellerOrgId),
                text: (resellerOrg === null || resellerOrg === void 0 ? void 0 : resellerOrg.name) || 'Loading...',
            },
            {
                to: '',
                text: "".concat((managedOrg === null || managedOrg === void 0 ? void 0 : managedOrg.name) || 'Loading...', ": Usage "),
            },
        ];
    }
    useEffect(function () {
        if (managedOrgId) {
            getDevPlanStatus(resellerOrgId, managedOrgId);
            getDevPlanInvoiceDetails(resellerOrgId, managedOrgId);
            listDeveloperPlans(resellerOrgId, managedOrgId);
            getManagedOrgConsumedDeveloperPlan(resellerOrgId, managedOrgId);
            getActiveBundles(resellerOrgId, managedOrgId);
            (activeDeveloperPlan === null || activeDeveloperPlan === void 0 ? void 0 : activeDeveloperPlan.id) &&
                listBundles(resellerOrgId, managedOrgId, activeDeveloperPlan.id);
        }
    }, [
        getManagedOrgConsumedDeveloperPlan,
        getDevPlanInvoiceDetails,
        listDeveloperPlans,
        getDevPlanStatus,
        getActiveBundles,
        listBundles,
        managedOrgId,
        resellerOrgId,
        activeDeveloperPlan.id,
    ]);
    var loadContent = function () {
        getDevPlanStatus(resellerOrgId, managedOrgId);
    };
    useSuccessToast('Developer plan successfully canceled', [!devPlanCancel_loading, !devPlanCancel_error], loadContent);
    useSuccessToast('Developer plan successfully activated', [!devPlanReactivate_loading, !devPlanReactivate_error], loadContent);
    useSuccessToast('Developer plan successfully purchased', [
        !developerPlanPurchase_loading,
        !developerPlanPurchase_error,
        !(purchasedDeveloperPlan === null || purchasedDeveloperPlan === void 0 ? void 0 : purchasedDeveloperPlan.client_secret),
    ]);
    useSuccessToast('Developer plan successfully Updated', [!purchase_dev_plan_bundle_loading, !purchase_dev_plan_bundle_error], loadContent);
    var onCancelDevPlan = function () {
        cancelDevPlan(resellerOrgId, managedOrgId);
        setOpenDevPlanCancelConfirmationModal(false);
    };
    return (_jsxs(_Fragment, { children: [_jsx(DevPlanCancelConfirmModal, { isVisible: openDevPlanCancelConfirmationModal, setIsVisible: setOpenDevPlanCancelConfirmationModal, primaryButtonAction: onCancelDevPlan, devPlanStatus: devPlanStatus }), _jsxs(PageWrapper, { children: [_jsx(Helmet, { children: _jsx("title", { children: "Developer Plans" }) }), _jsx(PageHeader, { children: _jsx(PageHeaderTitle, { children: _jsx(Breadcrumbs, { crumbs: crumbs }) }) }), _jsx(DevPlanUsageComponent, { devPlanConsume: devPlanConsume, devPlanConsumeOrg: devPlanConsumeOrg, developerPlansOrg: developerPlansOrg, activeDeveloperPlan: activeDeveloperPlan, devPlanStatus: devPlanStatus, devPlanStatusOrg: devPlanStatusOrg, setOpenDevPlanCancelConfirmationModal: setOpenDevPlanCancelConfirmationModal, onReactivateDevPlan: reactivateDevPlan, actionLoading: devPlanCancel_loading ||
                            devPlanReactivate_loading ||
                            devPlanStatusLoading, devPlanStatusLoading: devPlanStatusLoading, activeBundles: activeBundles, activeBundlesOrg: activeBundlesOrg, devPlanInvoiceDetails: devPlanInvoiceDetails, devPlanInvoiceDetailsOrg: devPlanInvoiceDetailsOrg, bundles: bundles, reseller: true })] })] }));
};
var mapStateToProps = function (state) { return ({
    devPlanConsume: makeSelectDeveloperPlanConsume(state),
    devPlanConsumeOrg: selectDeveloperPlanConsumeOrg(state),
    devPlanStatus: selectDeveloperPlanStatus(state),
    devPlanStatusLoading: selectDeveloperPlanStatusLoading(state),
    organizations: selectOrganizations(state),
    activeDeveloperPlan: makeSelectActiveDeveloperPlan(state),
    activeBundles: makeSelectActiveBundles(state),
    activeBundlesOrg: selectActiveBundlesOrg(state),
    developerPlansOrg: selectDeveloperPlansOrg(state),
    devPlanStatusOrg: selectDevPlanStatusOrg(state),
    bundles: selectDevPlanBundles(state),
    devPlanInvoiceDetails: selectDevPlanInvoiceDetails(state),
    devPlanInvoiceDetailsOrg: selectDevPlanInvoiceDetailsOrg(state),
    purchase_dev_plan_bundle_loading: selectPurchaseDevPlanBundleLoading(state),
    purchase_dev_plan_bundle_error: selectPurchaseDevPlanBundleError(state),
}); };
var mapDispatchToProps = function (dispatch) { return ({
    listDeveloperPlans: function (resellerOrgId, managedOrgId) {
        dispatch(actions.getManageDevPlanByResellerId(resellerOrgId, managedOrgId));
    },
    getManagedOrgConsumedDeveloperPlan: function (resellerOrgId, managedOrgId) {
        dispatch(actions.getManagedOrgConsumedDeveloperPlan(resellerOrgId, managedOrgId));
    },
    getActiveBundles: function (resellerOrgId, managedOrgId) {
        return dispatch(actions.getActiveBundles(resellerOrgId, managedOrgId));
    },
    getDevPlanStatus: function (resellerOrgId, managedOrgId) {
        dispatch(actions.getManagedOrgDevPlanStatus(resellerOrgId, managedOrgId));
    },
    cancelDevPlan: function (resellerOrgId, managedOrgId) {
        dispatch(actions.cancelDevPlan(resellerOrgId, managedOrgId));
    },
    reactivateDevPlan: function (resellerOrgId, managedOrgId) {
        dispatch(actions.reactivateDevPlanStatus(resellerOrgId, managedOrgId));
    },
    listBundles: function (resellerOrgId, managedOrgId, DevPlanId) {
        dispatch(actions.listBundlesPurchasableByManagedOrg(resellerOrgId, managedOrgId, DevPlanId));
    },
    getDevPlanInvoiceDetails: function (resellerOrgId, managedOrgI) {
        dispatch(actions.getDevPlanInvoiceDetails(resellerOrgId, managedOrgI));
    },
}); };
var withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(withConnect)(ResellerSelectedManagedOrgDevPlansPage);
